import { cn } from '@/lib/utils';
import { SelectableParagraphFontSizes, SelectableColors } from '@/types/content';
import React from 'react';
import parse from 'html-react-parser';
interface ParagraphProps {
  text?: string;
  fontSize?: SelectableParagraphFontSizes;
  textColor?: SelectableColors;
  centerAlign?: boolean;
  reducedBottomSpacing?: boolean;
  attributes?: React.HTMLProps<HTMLDivElement>;
} 

export const Paragraph = ({ 
  text, 
  fontSize, 
  textColor = 'primary', 
  centerAlign = false,
  attributes,
  reducedBottomSpacing = false,
}: ParagraphProps) => {
  const { key, ...rest } = attributes ?? {};

  const spacingClass = cn(
    reducedBottomSpacing ? '-mb-6' : '',
  );

  const paragraphClass = cn(
    fontSize === 'small' ? 'paragraph-sm' :
    fontSize === 'base' ? 'paragraph-base' :
    fontSize === 'large' ? 'paragraph-lg' :
    ''
  );
  const textColorClass = cn(
    textColor === 'brand' ? 'text-[var(--brand)]' :
    textColor === 'primary' ? 'text-primary' :
    textColor === 'secondary' ? 'text-muted-foreground' :
    ''
  );
  const centerAlignClass = centerAlign ? 'text-center' : '';

  return (
    <div
      key={key}
      {...rest}
      className={cn('content-paragraph', paragraphClass, spacingClass)}
    >
      <div className={cn(
        "[&_ul]:pl-6 [&_ul]:pb-6 [&_ul]:list-disc [&_ul]:marker:text-primary",
        "[&_ol]:pl-6 [&_ol]:pb-6 [&_ol]:list-decimal [&_ol]:marker:text-primary",
        "[&_li]:pb-1 [&_li]:last:pb-0",
        textColorClass, 
        centerAlignClass
      )} >
        {parse(text ?? '')}
      </div>
    </div>
  );
}; 